import { Directive } from '@angular/core';

@Directive({
    selector: '[furyPageLayoutContent],fury-page-layout-content',
    host: {
        class: 'fury-page-layout-content'
    },
    standalone: false
})
export class PageLayoutContentDirective {

  constructor() { }

}
